var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftPagiHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.88102 8.46764L10.061 5.28764C10.1307 5.21735 10.2137 5.16155 10.3051 5.12348C10.3965 5.0854 10.4945 5.0658 10.5935 5.0658C10.6925 5.0658 10.7906 5.0854 10.882 5.12348C10.9733 5.16155 11.0563 5.21735 11.126 5.28764C11.2657 5.42817 11.3441 5.61826 11.3441 5.81639C11.3441 6.01453 11.2657 6.20462 11.126 6.34514L8.47102 9.00014L11.126 11.6551C11.2657 11.7957 11.3441 11.9858 11.3441 12.1839C11.3441 12.382 11.2657 12.5721 11.126 12.7126C11.0559 12.7822 10.9728 12.8371 10.8815 12.8745C10.7901 12.9118 10.6922 12.9307 10.5935 12.9301C10.4948 12.9307 10.397 12.9118 10.3056 12.8745C10.2142 12.8371 10.1311 12.7822 10.061 12.7126L6.88102 9.53264C6.81073 9.46292 6.75493 9.37997 6.71685 9.28858C6.67878 9.19718 6.65917 9.09915 6.65917 9.00014C6.65917 8.90114 6.67878 8.80311 6.71685 8.71171C6.75493 8.62032 6.81073 8.53737 6.88102 8.46764Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPagiHover);
export default __webpack_public_path__ + "static/media/left_pagi_hover.2ee6e67e4b19dee345f2fc5f6b2bff20.svg";
export { ForwardRef as ReactComponent };